var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowBendLeftUp = function SvgIconArrowBendLeftUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.043 2.293a1 1 0 0 1 1.414 0l4.5 4.5a1 1 0 0 1-1.414 1.414L10.75 5.414V12a8 8 0 0 0 8 8 1 1 0 1 1 0 2 10 10 0 0 1-10-10V5.414L5.957 8.207a1 1 0 0 1-1.414-1.414z"
  })));
};
export default SvgIconArrowBendLeftUp;